module.exports = __webpack_public_path__ + "static/media/bat0.5a10fe3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat0.png
// module id = 209
// module chunks = 0